import React from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';
import OPComponent from '../../op_component';
import ArrowRight from '../../display/arrow_right';

export default class ListItem extends OPComponent {
  constructor(props) {
    super(props);
  }

  handleItemTap = () => {
    const { item } = this.props.item;
    this.props.onPress && this.props.onPress(item);
  };

  render() {
    const { height } = this.props;

    const { label, subLabel } = this.props.item;

    return (
      <Pressable style={[styles.listItem, { height }]} onPress={this.handleItemTap}>
        <View style={styles.listItemText}>
          <Text style={styles.listItemLabel}>{label}</Text>
          <Text style={styles.listItemSubLabel}>{subLabel}</Text>
        </View>
        <ArrowRight />
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  listItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 25,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
  },
  listItemText: {
    flex: 1,
    marginRight: 20,
  },
  listItemLabel: {
    ...FONT.bold,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
    marginBottom: 10,
  },
  listItemSubLabel: {
    ...FONT.mediumItalic,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
  },
});
